import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { AuthUtils } from '../auth/auth.utils';

@Injectable({ providedIn: 'root' })
export class RoleService {
    constructor(private _authService: AuthService) {}

    public isInRole(roles: string[]): boolean {
        if (roles != undefined && roles.length > 0) {
            let isInRole = false;
            const userRoles = AuthUtils.getTokenRoles(
                this._authService.accessToken
            );

            roles.forEach((role) => {
                if (userRoles.indexOf(role) > -1) {
                    isInRole = true;
                }
            });

            return isInRole;
        } else {
            return false;
        }
    }
}
